import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { COLOR_CONSTANTS } from "../../constants/styles";

const LOGO_WIDTH_PX = { small: 72, large: 160 } as const;

/** 로딩 표시가 걷히고 사진이 드러나는 시간 — 표시를 쓰는 자리가 모두 같은 값을 쓴다 */
export const IMAGE_FADE_IN_MS = 240;

/**
 * 이미지가 도착하기를 기다리는 동안 그 자리를 채우는 표시.
 * 드론 이미지 목록 카드와 부동 뷰어가 같은 모양을 쓴다 — 빈 회색 판만 있으면 오류로 읽힌다.
 */
export function ImageLoadingPlaceholder({
  size = "small",
}: {
  size?: "small" | "large";
}) {
  const { t } = useTranslation("common");

  return (
    <Box sx={container} role="status" aria-label={t("queryState.imageLoading")}>
      <Box
        component="img"
        src="/icons/logo/main.svg"
        alt=""
        sx={[logo, { width: `${LOGO_WIDTH_PX[size]}px` }]}
      />
    </Box>
  );
}

const container = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: COLOR_CONSTANTS.COLOR.BLUE_GREY[50],
  pointerEvents: "none",
} as const;

const logo = {
  maxWidth: "60%",
  animation: "drone-image-logo-fade 1.6s ease-in-out infinite",
  "@keyframes drone-image-logo-fade": {
    "0%, 100%": { opacity: 0.25 },
    "50%": { opacity: 0.7 },
  },
} as const;
